import React, { useEffect, useState } from 'react';
import heroImage3 from "../../Images/Webinar-amico (1) 1.png";
import AboutImamge from "../../Images/Frame 12.png";
import FactImage from "../../Images/fact_img.png.png";
import HomeNavbar from './HomeNavbar';
import { Link } from 'react-scroll';
import { FaArrowRightLong } from 'react-icons/fa6';
import CountUp from 'react-countup';
import Contactus from './Contactus';
import Footer from './Footer';

import ReferShare from "../../Images/referlink.png";

import QuamaImage from "../../Images/quamaImage.png";
import Ratingstars from "../../Images/ratingstar.png";
import Slider from 'react-slick';

const Aboutus = () => {

    
  const [slideIn, setSlideIn] = useState(false);
  const settings = {
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: true,
    // dots: true,
    accessibility: false,
    adaptiveHeight: true,
    // dots: true,
    autoplay: true,
    speed: 1000,
    autoplaySpeed: 4000,
    // nextArrow: <SampleNextArrow/>,
    // prevArrow: <SamplePrevArrow />,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 3,
          infinite: true,
          // dots: true,
          autoplay: true,
          speed: 2000,
          autoplaySpeed: 5000,
          // dots: true
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          // dots: true,
          autoplay: true,
          speed: 2000,
          autoplaySpeed: 5000,
          // initialSlide: 2
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
          // dots: true,
          autoplay: true,
          speed: 2000,
          autoplaySpeed: 5000,
          // cssEase: "linear"
        },
      },
    ],
  };
  useEffect(() => {
    setSlideIn(true);
  }, []);

    return (
        <>
        <HomeNavbar/>
        <div className="lg:w-4/5  flex flex-col lg:flex-row items-center m-20 font-poppins text-center ">
                     <div
                       className={`lg:w-1/2 ${
                         slideIn ? "animate-slide-in-right" : ""
                       } `}
                     >
                       <img
                         src={AboutImamge}
                         alt="About"
                         className=" lg:max-w-2xl w-96  m-auto lg:m-0"
                       />
                     </div>
                     <div className={`w-full lg:w-1/2 lg:text-start  p-2 lg:p-0`}>
                       <br />
       
                       <h1 className="text-2xl lg:text-3xl font-bold font-poppins text-bgBlue mb-4 animate-slide-in-left">
                         Empowering Students to reach their{" "}
                         <span className="text-purple">potential</span> Goal For Next
                         Level Challenge.{" "}
                       </h1>
       
                       <p className="text-sm  text-bgBlue mb-6 animate-slide-in-left">
                         Empowering students to reach their potential involves
                         providing them with the tools, resources, and support needed
                         to overcome challenges and achieve their goals. By fostering a
                         growth mindset, offering personalized learning experiences,
                         and encouraging perseverance, students can be prepared to
                         tackle the next level of their educational and professional
                         journeys. This holistic approach not only boosts their
                         confidence but also equips them with the skills necessary for
                         lifelong success.{" "}
                       </p>
                       <div className="mt-6">
                         <Link to={"/login"}>
                           <div className="w-44 flex m-auto lg:m-0 py-2.5 justify-center items-center gap-4 rounded-full bg-purple text-white shadow-[6px_6px_#4D2C5E] transition duration-300">
                             <button>Start Free Trial</button>
                             <FaArrowRightLong />
                           </div>
                         </Link>
                       </div>
                     </div>
                   </div>
                    <div className="w-full flex justify-center items-center bg-white  lg:p-0 mt-4 ">
              <div className="bg-bgBlue lg:p-8 p-4 m-10 lg:rounded-lg flex lg:flex-row flex-col gap-6 lg:gap-0 justify-between items-center lg:w-4/5 w-full ">
                <div className="text-center">
                  <p className="lg:text-3xl font-bold text-white">
                    <CountUp end={4500} duration={2} />
                    K+
                  </p>
                  <p className="text-sm text-gray-300">Number of Users</p>
                </div>
                {/* <div className="border-l border-gray-200 h-16 block hidden"></div> */}
                <div className="text-center ">
                  <p className="lg:text-3xl font-bold text-white">
                    <CountUp end={4.6} duration={2} decimals={1} />
                  </p>
                  <p className="text-sm text-gray-300">Star Rating</p>
                </div>
                {/* <div className="border-l border-gray-200 h-16 "></div> */}
                <div className="text-center">
                  <p className="lg:text-3xl font-bold text-white">
                    <CountUp end={328} duration={2} />+
                  </p>
                  <p className="text-sm text-gray-300">Number Of Tests Taken</p>
                </div>
                {/* <div className="border-l border-gray-200 h-16 "></div> */}
                <div className="text-center">
                  <p className="lg:text-3xl font-bold text-white">
                    <CountUp end={80} duration={2} />
                    K+
                  </p>
                  <p className="text-sm text-gray-300">Questions Attempted</p>
                </div>
                {/* <div className="border-l border-gray-200 h-16 "></div> */}
                <div className="relative w-48 lg:h-32 h-24 hidden ">
                  <img
                    src={FactImage}
                    alt="Statistics"
                    className="absolute top-0 left-0 w-full h-full object-contain"
                  />
                </div>
              </div>
            </div>
             <div
            id="Testimonials"
            className="bg-white w-full  text-center font-oswald"
          >
            <div className=" flex items-center justify-center">
              <p
                style={{ backgroundColor: "#EFEEFE" }}
                className="border-2 border rounded-full py-2 px-6 font-bold text-bgBlue"
              >
                Our Testimonials
              </p>
            </div>
            <br />
            <h2 className="text-3xl font-bold text-gray-900 mb-2 animate-fade-in">
              What Students Think and Say About{" "}
              <span className="text-purple">Learn2Earn24x7</span>{" "}
            </h2>
            <p className=" text-sm text-gray-900 mb-4 animate-fade-in lg:w-1/2 lg:m-auto ">
            “I not only gained new skills but also started earning through what I learned!”
            </p>
            <br />
            <div class="py-2 px-6  lg:px-20">
              <Slider {...settings} className="slider-container">
                <div
                  style={{ backgroundColor: "#F6F5FE" }}
                  class="  w-full   xl:p-5 p-6 rounded-xl "
                >
                  {/* <div className="flex justify-end">
                <img src={Star} alt="" />
              </div> */}
                  <div className="flex justify-between p-4 w-full">
                    <div className="flex  gap-6 justify-center items-center">
                      <div className="  flex justify-between   ">
                        <img src={ReferShare} alt="" className="w-12 h-12 " />
                      </div>

                      <div class="flex flex-col gap-2 m-auto lg:m-0 text-start  ">
                        <img src={Ratingstars} alt="" />
                        <span class=" text-xl font-semibold font-oswald text-black ">
                          Meenal Jain
                        </span>
                      </div>
                    </div>
                    <div>
                      <img src={QuamaImage} alt="" className="w-12 " />
                    </div>
                  </div>

                  <span class=" text-sm font-bold text-start flex mt-2 xl:px-8">
                    "A good Platform for Beginers and Learns to get Knowledge".
                  </span>
                </div>
                <div
                  style={{ backgroundColor: "#F6F5FE" }}
                  class="   max-w-md  xl:p-5 p-6 rounded-xl h-48  "
                >
                  {/* <div className="flex justify-end">
                <img src={Star} alt="" />
              </div> */}
                  <div className="flex justify-between p-4">
                    <div className="flex  gap-6 justify-center items-center">
                      <div className="  flex justify-between   ">
                        <img src={ReferShare} alt="" className="w-12 h-12 " />
                      </div>

                      <div class="flex flex-col gap-2 m-auto lg:m-0 text-start  ">
                        <img src={Ratingstars} alt="" />
                        <span class=" text-xl font-semibold font-oswald text-black ">
                          Lokesh Kumar
                        </span>
                      </div>
                    </div>
                    <div>
                      <img src={QuamaImage} alt="" className="w-12 " />
                    </div>
                  </div>

                  <span class=" text-sm font-bold text-start flex mt-2 xl:px-8">
                    "Amazing Paltform for Learning and Earnig for Students".
                  </span>
                </div>
                <div
                  style={{ backgroundColor: "#F6F5FE" }}
                  class="   max-w-md  xl:p-5 p-6 rounded-xl h-48  "
                >
                  {/* <div className="flex justify-end">
                <img src={Star} alt="" />
              </div> */}
                  <div className="flex justify-between p-4">
                    <div className="flex  gap-6 justify-center items-center">
                      <div className="  flex justify-between   ">
                        <img src={ReferShare} alt="" className="w-12 h-12 " />
                      </div>

                      <div class="flex flex-col gap-2 m-auto lg:m-0 text-start  ">
                        <img src={Ratingstars} alt="" />
                        <span class=" text-xl font-semibold font-oswald text-black ">
                          Rishikesh Suryawanshi
                        </span>
                      </div>
                    </div>
                    <div>
                      <img src={QuamaImage} alt="" className="w-12 " />
                    </div>
                  </div>

                  <span class=" text-sm font-bold text-start flex mt-2 xl:px-8">
                    "Easiest Way to Explore new things and Kwonledge".
                  </span>
                </div>
                <div
                  style={{ backgroundColor: "#F6F5FE" }}
                  class="   max-w-md  xl:p-5 p-6 rounded-xl h-48  "
                >
                  {/* <div className="flex justify-end">
                <img src={Star} alt="" />
              </div> */}
                  <div className="flex justify-between p-4">
                    <div className="flex  gap-6 justify-center items-center">
                      <div className="  flex justify-between   ">
                        <img src={ReferShare} alt="" className="w-12 h-12 " />
                      </div>

                      <div class="flex flex-col gap-2 m-auto lg:m-0 text-start  ">
                        <img src={Ratingstars} alt="" />
                        <span class=" text-xl font-semibold font-oswald text-black ">
                          Neha Shah
                        </span>
                      </div>
                    </div>
                    <div>
                      <img src={QuamaImage} alt="" className="w-12 " />
                    </div>
                  </div>

                  <span class=" text-sm font-bold text-start flex mt-2 xl:px-8">
                    "Best Thing for Learns to get Knowledge".
                  </span>
                </div>
                <div
                  style={{ backgroundColor: "#F6F5FE" }}
                  class="   max-w-md  xl:p-5 p-6 rounded-xl h-48  "
                >
                  {/* <div className="flex justify-end">
                <img src={Star} alt="" />
              </div> */}
                  <div className="flex justify-between p-4">
                    <div className="flex  gap-6 justify-center items-center">
                      <div className="  flex justify-between   ">
                        <img src={ReferShare} alt="" className="w-12 h-12 " />
                      </div>

                      <div class="flex flex-col gap-2 m-auto lg:m-0 text-start  ">
                        <img src={Ratingstars} alt="" />
                        <span class=" text-xl font-semibold font-oswald text-black ">
                          Nilesh Tiwari
                        </span>
                      </div>
                    </div>
                    <div>
                      <img src={QuamaImage} alt="" className="w-12 " />
                    </div>
                  </div>

                  <span class=" text-sm font-bold text-start flex mt-2 xl:px-8">
                    "Little progress each day adds up to big results".
                  </span>
                </div>
                <div
                  style={{ backgroundColor: "#F6F5FE" }}
                  class="   max-w-md  xl:p-5 p-6 rounded-xl h-48  "
                >
                  {/* <div className="flex justify-end">
                <img src={Star} alt="" />
              </div> */}
                  <div className="flex justify-between p-4">
                    <div className="flex  gap-6 justify-center items-center">
                      <div className="  flex justify-between   ">
                        <img src={ReferShare} alt="" className="w-12 h-12 " />
                      </div>

                      <div class="flex flex-col gap-2 m-auto lg:m-0 text-start  ">
                        <img src={Ratingstars} alt="" />
                        <span class=" text-xl font-semibold font-oswald text-black ">
                          Mehul Sharma
                        </span>
                      </div>
                    </div>
                    <div>
                      <img src={QuamaImage} alt="" className="w-12 " />
                    </div>
                  </div>

                  <span class=" text-sm font-bold text-start flex mt-2 xl:px-8">
                    "Grow your skills, and your income will grow with them".
                  </span>
                </div>
              </Slider>
            </div>
          </div>
          <Contactus />
         
        </>
    );
}

export default Aboutus;
